import { css } from 'styled-components';

export const colors = {
  darkBlue_darker: '#0E2656',
  darkBlue_dark: '#435579',
  darkBlue_main: '#79859D',
  darkBlue_light: '#BABFC8',
  darkBlue_lighter: '#DCDFE3',
  blue_darker: '#4783FF',
  blue_dark: '#7EA8FF',
  blue_main: '#B5CDFF',
  blue_light: '#E3ECFF',
  blue_lighter: '#F8F8FF',
  blue_lightest: '#FCFCFE',
  green_darker: '#16B6A3',
  green_dark: '#52D4C5',
  green_main: '#7DDFD3',
  green_light: '#A8E9E2',
  green_lighter: '#DCF6F3',
  yellow_dark: '#FFD289',
  yellow_main: '#FFDFAC',
  yellow_light: '#FFEDD0',
  yellow_lighter: '#FFF8ED',
  purple_dark: '#8A61FF',
  purple_main: '#A788FF',
  purple_light: '#C5B0FF',
  purple_lighter: '#E8DFFF',
  white: '#FFFFFF'
};

export const navPanelWidth = '14.8rem';

export const authImageWidth = '63.8rem';

export const containerStyles = css`
  box-shadow: 1.1rem 1.1rem 3.4rem rgba(227, 229, 245, 0.77);
  border-radius: 3rem;
  background: white;
`;

export const scrollStyles = css`
  ::-webkit-scrollbar {
    width: 0.5rem;
  }

  ::-webkit-scrollbar-thumb {
    min-height: 4.6rem;
    background: ${colors.blue_light};
    border-radius: 0.6rem;
  }
`;

export const mediaQueries = {
  mobileMax: 'screen and (max-width: 767px)',
  desktopMin: 'screen and (min-width: 768px)'
};
